import { render, staticRenderFns } from "./AddAdditionalFoldersModal.vue?vue&type=template&id=2db06060&scoped=true&"
import script from "./AddAdditionalFoldersModal.vue?vue&type=script&lang=ts&"
export * from "./AddAdditionalFoldersModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddAdditionalFoldersModal.vue?vue&type=style&index=0&id=2db06060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db06060",
  null
  
)

export default component.exports